import React, { useEffect, useState } from 'react'
import Gstate from "./StoreState/Gstate";
import Janani from "./Janani";
import { Routes, Route } from "react-router-dom";
import ShowError from './ShowError';

function App() {

  return (
    <div >
      <Gstate>
        <Routes>
          <Route path="/error" element={<ShowError />} />
          <Route path="/" element={<Janani />} />
        </Routes>
      </Gstate>
    </div>
  )
}


export default App